
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const JsonFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
  onChange: (value: string, layoutField: LayoutFieldModel) => void
}> = ( {
  layoutField,
  value,
  onChange
}) => {

  const [jsonError, setJsonError] = useState<string | null>(null);


  const handleChange = (event: any) => {
    const value = event.target.value;

    onChange(value, layoutField);
  }

  const handleBlur = (event: any) => {
    const value = event.target.value
    try {
      const parsedValue = JSON.parse(value);
      const stringValue = JSON.stringify(parsedValue, null, 2);
      setJsonError(null);
      onChange(stringValue, layoutField);
    } catch {
      setJsonError("Invalid JSON")
    }
  }


  const required = checkLayoutFieldRequirement(layoutField);

  const error = () => {
    if(required &&
       (!value || value == "\"\"")){
         return true
       }
    if(jsonError){
      return true
    }

    return false
  };

  const getHelperText = () => {
    let errorMessage = ''
    if(layoutField.ReferencedField_sys.HelpText_sys && jsonError){
      return `${layoutField.ReferencedField_sys.HelpText_sys} -- ${jsonError}`
    }
    if(jsonError){
      return `${jsonError}`
    }
    return layoutField.ReferencedField_sys.HelpText_sys
  }


  return (
      <TextField
         fullWidth
         error={error()}
         disabled={layoutField.AccessSetting_sys === 'read'}
         multiline={true}
         rows={10}
         required={required}
         size="small"
         label={`${layoutField.ReferencedField_sys.Label_sys}`}
         variant="filled"
         value={value}
         onChange={(event) => handleChange(event)}
         onBlur={(event) => handleBlur(event)}
         helperText={getHelperText()}
         inputProps={{
           maxLength: layoutField.ReferencedField_sys.Length_sys,
         }}
//         InputProps={{
//           disableUnderline: false,
//         }}
      />

    );

};
